import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { builtFor, notFor } from '../data/content';
import { Reveal } from './showcase/Reveal';
import { FunnelStrip } from './showcase/FunnelStrip';
export function WhoItIsFor() {
  return <section id="fit" aria-labelledby="fit-title" className="border-b border-white/5 bg-ink-900" data-id="element-424" data-mp="d590tysxd9bx">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-425" data-mp="83tbhujpsgnq">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-426" data-mp="15swfyybff7r6">
          Fit
        </p>
        <h2 id="fit-title" className="mt-5 max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-427" data-mp="10v3c4bxlipu2">
          Who it is for.
        </h2>
        <p className="mt-4 max-w-xl text-sm text-white/55" data-id="element-428" data-mp="qy8b9mduodcm">
          Real lead spend, real volume, appointments as the bottleneck.
        </p>

        <Reveal className="mt-12" data-id="element-429" data-mp="3bm3exct33lef">
          <FunnelStrip data-id="element-430" data-mp="3bkth8oq58f8b" />
        </Reveal>

        <div className="mt-5 grid gap-5 md:grid-cols-2" data-id="element-431" data-mp="b8dzrhujk4hl">
          <div className="rounded-xl border border-brand/35 bg-ink-700 p-7 sm:p-8" data-id="element-432" data-mp="b8w3t0ng3n02">
            <h3 className="font-display text-xl font-semibold tracking-tight text-brand" data-id="element-433" data-mp="g5wddlji77vx">
              Built for
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-434" data-mp="1c1acw614csn">
              {builtFor.map(item => <li key={item} className="flex items-start gap-3 text-sm text-white/75" data-id="element-435" data-mp="676tjn81rdd1">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand" aria-hidden="true" data-id="element-436" data-mp="3olfwvsudhbxs" />
                  <span className="leading-relaxed" data-id="element-437" data-mp="3epcy8wyqbvfl">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-xl border border-white/10 bg-ink-700 p-7 sm:p-8" data-id="element-438" data-mp="3jopid9y7uoeh">
            <h3 className="font-display text-xl font-semibold tracking-tight text-white/70" data-id="element-439" data-mp="35p7t6th0d94l">
              Not for
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-440" data-mp="39oysjlkloxkq">
              {notFor.map(item => <li key={item} className="flex items-start gap-3 text-sm text-white/55" data-id="element-441" data-mp="1g8lxgidu2ugz">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-white/35" aria-hidden="true" data-id="element-442" data-mp="1bfj3wa923l0s" />
                  <span className="leading-relaxed" data-id="element-443" data-mp="11iepwxpd6vv2">{item}</span>
                </li>)}
            </ul>
            <p className="mt-7 border-t border-white/10 pt-6 text-sm leading-relaxed text-white/70" data-id="element-444" data-mp="1z6ez7hcq0ycs">
              We do not sell leads. We stop you from losing the ones you already pay for.
            </p>
          </div>
        </div>
      </div>
    </section>;
}